import React, { useState, useEffect } from 'react';
import RestaurantForm from './RestaurantForm';
import { fetchAPI } from 'shared/api';

const RestaurantProfile = ({ token, restaurant: propRestaurant, refreshRestaurant }) => {
  const [restaurant, setRestaurant] = useState(propRestaurant || null);
  const [refresh, setRefresh] = useState(false);
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Sync with prop
  useEffect(() => {
    setRestaurant(propRestaurant || null);
  }, [propRestaurant]);

  // Only fetch if no prop provided
  useEffect(() => {
    const fetchRestaurant = async () => {
      try {
        const response = await fetchAPI('/restaurant/manager', {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` }
        });
        console.log('Fetched restaurant response : ',response);
      
        if (response.status === 404){
           console.log('Fetched restaurant data: failed 404');
           return null;
        }
        if (!response.ok) {
          console.log('Fetched restaurant error:', response);
          throw new Error('Failed to fetch restaurant');
        }
        const data = await response.json();
        console.log('Fetched restaurant data:', data);
        if (Array.isArray(data) && data.length > 0) return data[0];
        return null;
      } catch (err) {
        return null;
      }
    };

    if (!propRestaurant && token) {
      fetchRestaurant().then(setRestaurant);
    }
  }, [token, refresh, propRestaurant]);

  if (!restaurant) {
    return (
      <div>
        <h2 className="text-2xl font-bold mb-4">Register Your Restaurant</h2>
        <RestaurantForm token={token} onSuccess={async () => {
          setRefresh(r => !r);
          if (refreshRestaurant) await refreshRestaurant();
        }} />
      </div>
    );
  }

  if (editing) {
    return (
      <div>
        <h2 className="text-2xl font-bold mb-4">Edit Restaurant</h2>
        <RestaurantForm
          token={token}
          initialData={restaurant}
          isEdit={true}
          onSuccess={async () => {
            setEditing(false);
            setSuccess('Restaurant updated successfully!');
            setError('');
            setRefresh(r => !r);
            if (refreshRestaurant) await refreshRestaurant();
          }}
          onCancel={() => setEditing(false)}
        />
        {error && <p className="text-red-500">{error}</p>}
        {success && <p className="text-green-500">{success}</p>}
      </div>
    );
  }

  // Show restaurant profile (minimal fields for now)
  return (
    <div className="max-w-md mx-auto p-4 bg-white shadow-md rounded">
      <h2 className="text-2xl font-bold mb-4">Restaurant Profile</h2>
      <div className="mb-2"><strong>Name:</strong> {restaurant.name || restaurant.restaurant_name}</div>
      <div className="mb-2"><strong>Address:</strong> {restaurant.address}</div>
      <div className="mb-2"><strong>Contact Number:</strong> {restaurant.details?.contact_number}</div>
      <div className="mb-2"><strong>WhatsApp Enabled:</strong> {restaurant.details?.is_whatsapp_enabled ? 'Yes' : 'No'}</div>
      <div className="mb-2"><strong>WhatsApp Consent:</strong> {restaurant.details?.whatsapp_message_consent ? 'Yes' : 'No'}</div>
      <div className="mb-2"><strong>Home Delivery:</strong> {restaurant.details?.home_delivery_supported ? 'Yes' : 'No'}</div>
      <div className="mb-2"><strong>Radius of Service (km):</strong> {restaurant.details?.radius_of_service}</div>
      <div className="mb-2"><strong>Minimum Order Amount:</strong> {restaurant.details?.minimum_order_amount}</div>
      <div className="mb-2"><strong>Cuisine:</strong> {restaurant.details?.cuisine || '-'}</div>
      <div className="mb-2"><strong>Vegetarian Type:</strong> {restaurant.details?.vegetarian_type || '-'}</div>
      <button
        className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        onClick={() => setEditing(true)}
      >
        Edit
      </button>
      {error && <p className="text-red-500">{error}</p>}
      {success && <p className="text-green-500">{success}</p>}
    </div>
  );
};

export default RestaurantProfile;
